






















import { Component, Prop, Vue } from 'vue-property-decorator';
import Setting from './Setting.vue';
import Warning from '@/components/page/Warning.vue';
import { PipelineService } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelineService';
import ProductPipelineSetting, { ProductPipelineSettingDTO } from '@/components/designer/ProductPipelineSetting.vue';
import ProductPublishHistory from '@/components/designer/ProductPublishHistory.vue';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { APPService } from '@/api/com/MetaPattern/MDA/MD/Base/APPService';
import { PipelinePublishTask } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelinePublishTask';

@Component({
  components: {
    Setting,
    Warning,
    ProductPipelineSetting,
    ProductPublishHistory
  }
})
export default class ProductPipeline extends Vue {
  @Prop() transferData!: any; // 结构：Json，{product: value; productId: value;}
  private showSetting = false;
  private key = 0;
  private historyKey = 0;
  private settingDTO: ProductPipelineSettingDTO;
  private pipelinePublishTask: PipelinePublishTask;
  private curTab = 'setting';

  constructor() {
    super();
    this.historyKey = 0;
    this.pipelinePublishTask = null;
    this.showSetting = false;
    this.settingDTO = new ProductPipelineSettingDTO();
  }

  mounted() {
    const product = this.transferData.product as Product;
    if (product && product !== null && product.productComponents.length > 0) {
      const productComponent = product.productComponents[0];
      BaseService.GetProductAPPsAsync(productComponent.id)
        .then(res => {
          const appIds = new Array<string>();
          res.forEach(productAPP => {
            productComponent.productAPPs.push(productAPP);
            appIds.push(productAPP.aPP_ID);
          });
          APPService.LoadByIdsAsync(appIds).then((apps) => {
            this.settingDTO.appList.push(...apps);
          }).catch((err) => {
            this.$message({ type: 'error', message: '加载产品下的应用失败：' + err });
          });
        });
      this.loadPublishSetting();
    } else {
      this.$message({ type: 'error', message: '产品下不包含应用，无法打开产品设置，请检查产品设计' });
    }
  }

  async loadPublishSetting(): Promise<boolean> {
    const product = this.transferData.product as Product;
    this.settingDTO.includeAppKeys = new Array<string>();
    PipelineService.GetLastPublishSettingAsync(product.designId, null)
      .then(res => {
        if (res && res !== null) {
          this.pipelinePublishTask = res;
          this.settingDTO.needCompile = res.needCompile;
          this.settingDTO.isTest = res.isTest;
          
          res.publishApps.forEach(item => {
            this.settingDTO.includeAppKeys.push(item.appKey);
          });
          return new Promise((resolve) => resolve(true));
        }
        return new Promise((resolve) => resolve(false));
      });
    return new Promise((resolve) => resolve(true));
  }

  setPublishSetting() {
    this.key++;
    this.showSetting = true;
  }

  viewSetting() {
    this.curTab = 'setting';
  }

  viewPublishHistory() {
    this.loadPublishSetting().then(res => {
      this.historyKey++;
      this.curTab = 'history';
    });
  }

  /** 全流程发布 */
  publishFull(needCompile: boolean, isTest: boolean, appKeys: Array<string>, includeFront: boolean) {
    if (this.transferData.productId) {
      const loadingText = '正在努力执行，大概需要10分钟左右，可通过发布历史查看具体进度...';
      const loading = this.$loading({
        lock: true,
        text: loadingText,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        if (isTest) {
          // 测试的时候，需要重新更新设置
          IDEContext.instance.getUserInfoAsync(IDEContext.instance.curAccountInfo.accountId, IDEContext.instance.curUser.id);
        }
      }, 5000);
      // 发布产品时间长，这里不等待返回
      PipelineService.PublishProductFullAsync(this.transferData.productId, needCompile, '', isTest, appKeys, includeFront.toString());
      // .then(res => {
      //   if (res) {
      //     if (isTest) {
      //       // 测试的时候，需要重新更新设置
      //       IDEContext.instance.getUserInfoAsync(IDEContext.instance.curAccountInfo.accountId, IDEContext.instance.curUser.id);
      //     }
      //     this.$message({ type: 'success', message: '流水线发布成功!' });
      //     this.$store.dispatch('ModuleMD/setOutputMessagesAction', `产品 [${this.transferData.product.name}] 流水线发布成功。`);
      //   }
      //   // loading.close();
      // })
      // .catch((error: any) => {
      //   console.log(error);
      //   // Important！！这里的错误处理与常规不一致
      //   this.$store.dispatch('ModuleMD/setOutputMessagesAction', '--------产品发布发生错误：');
      //   const errInfo = JSON.parse(error);
      //   EnumPipelinePhaseMD.getItems().forEach(item => {
      //     if (errInfo[item.name]) {
      //       this.$store.dispatch('ModuleMD/setOutputMessagesAction', `[${item.displayName}] 阶段共有错误数： ${errInfo[item.name].length}`);
      //       errInfo[item.name].forEach((errLine: any) => {
      //         this.$store.dispatch('ModuleMD/setOutputMessagesAction', `[${item.displayName}] ${errLine}`);
      //       });
      //     }
      //   });
      //   this.$message({ type: 'error', message: '流水线发布失败!原因详见输出窗口' });
      //   // loading.close();
      // });
    }
  }

  closeSetting(setting: ProductPipelineSettingDTO) {
    this.showSetting = false;
    if (setting !== null) {
      this.settingDTO = setting;
      this.publishFull(this.settingDTO.needCompile, this.settingDTO.isTest, this.settingDTO.includeAppKeys, this.settingDTO.includeFront);
    }
  }
}
